var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: { "append-to-body": "", visible: _vm.dialogVisible, width: "70%" },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticStyle: { "margin-bottom": "0.2rem", "font-size": "0.2rem" } },
        [
          _c("span", [_vm._v("发票金额的总和必须小于或等于订单金额")]),
          _vm._v(" 订单总额："),
          _c(
            "span",
            { staticStyle: { color: "red", "margin-right": "0.1rem" } },
            [_vm._v("¥" + _vm._s(_vm.orderPrice))]
          ),
          _vm._v(" 已开发票金额："),
          _c("span", { staticStyle: { color: "red" } }, [
            _vm._v("¥" + _vm._s(_vm.totalAmount)),
          ]),
          _vm.tableData.length > 0
            ? _c(
                "span",
                {
                  staticStyle: {
                    "margin-left": "0.2rem",
                    "font-size": "0.17rem",
                    cursor: "pointer",
                    "text-decoration": "underline",
                    color: "#CB582E",
                  },
                  on: { click: _vm.selectInvoiceInfo },
                },
                [_vm._v("选择已有数据")]
              )
            : _vm._e(),
        ]
      ),
      _vm._l(_vm.invoicingDetailList, function (item, index) {
        return _c(
          "div",
          {
            key: _vm.invoicingDetailList.length + index,
            staticClass: "lineBox",
          },
          [
            _c("div", { staticClass: "lineBoxTitle" }, [
              _c("p", { staticClass: "lineBoxTitleP1" }, [
                _vm._v("第" + _vm._s(index + 1) + "张发票"),
              ]),
              _c(
                "p",
                {
                  staticClass: "lineBoxTitleP2",
                  staticStyle: { "margin-right": "0.3rem" },
                  on: {
                    click: function ($event) {
                      return _vm.addClick(item)
                    },
                  },
                },
                [_vm._v("增加")]
              ),
              _vm.invoicingDetailList.length > 2
                ? _c(
                    "p",
                    {
                      staticClass: "lineBoxTitleP2",
                      on: {
                        click: function ($event) {
                          return _vm.deleteClick(index)
                        },
                      },
                    },
                    [_vm._v("删除")]
                  )
                : _vm._e(),
            ]),
            _c("div", { staticClass: "cardLineLineBox" }, [
              _c(
                "div",
                { staticClass: "cardLine" },
                [
                  _c(
                    "p",
                    {
                      staticClass: "cardLineP1",
                      staticStyle: { "margin-right": "0.2rem" },
                    },
                    [_c("span", [_vm._v("*")]), _vm._v("发票类型:")]
                  ),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "3rem" },
                      attrs: { size: "small", placeholder: "请选择" },
                      model: {
                        value: item.type,
                        callback: function ($$v) {
                          _vm.$set(item, "type", $$v)
                        },
                        expression: "item.type",
                      },
                    },
                    _vm._l(_vm.options, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "cardLine" },
                [
                  _c(
                    "p",
                    {
                      staticClass: "cardLineP1",
                      staticStyle: { "margin-right": "0.2rem" },
                    },
                    [_c("span", [_vm._v("*")]), _vm._v("发票抬头:")]
                  ),
                  _c("el-input", {
                    staticStyle: { width: "3rem" },
                    attrs: { placeholder: "公司名称", size: "small" },
                    model: {
                      value: item.lookUp,
                      callback: function ($$v) {
                        _vm.$set(item, "lookUp", $$v)
                      },
                      expression: "item.lookUp",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "cardLine" },
                [
                  _c(
                    "p",
                    {
                      staticClass: "cardLineP1",
                      staticStyle: { "margin-right": "0.2rem" },
                    },
                    [_c("span", [_vm._v("*")]), _vm._v("税号:")]
                  ),
                  _c("el-input", {
                    staticStyle: { width: "3rem" },
                    attrs: { placeholder: "纳税人识别号", size: "small" },
                    model: {
                      value: item.duty,
                      callback: function ($$v) {
                        _vm.$set(item, "duty", $$v)
                      },
                      expression: "item.duty",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "cardLine" },
                [
                  _c(
                    "p",
                    {
                      staticClass: "cardLineP1",
                      staticStyle: { "margin-right": "0.2rem" },
                    },
                    [_c("span", [_vm._v("*")]), _vm._v("发票金额:")]
                  ),
                  _c("el-input", {
                    staticStyle: { width: "3rem" },
                    attrs: { placeholder: "请输入发票金额", size: "small" },
                    model: {
                      value: item.price,
                      callback: function ($$v) {
                        _vm.$set(item, "price", $$v)
                      },
                      expression: "item.price",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "cardLine" },
                [
                  _c(
                    "p",
                    {
                      staticClass: "cardLineP1",
                      staticStyle: { "margin-right": "0.2rem" },
                    },
                    [_c("span", [_vm._v("*")]), _vm._v("发票内容:")]
                  ),
                  _c("el-input", {
                    staticStyle: { width: "3rem" },
                    attrs: { placeholder: "请输入发票内容", size: "small" },
                    model: {
                      value: item.remark,
                      callback: function ($$v) {
                        _vm.$set(item, "remark", $$v)
                      },
                      expression: "item.remark",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("p", [_vm._v("发票金额以实际开票金额为准")]),
          ]
        )
      }),
      _c("thereIsAlreadyAnInvoicePopUpBox", {
        ref: "thereIsAlreadyAnInvoicePopUpBox",
        attrs: {
          tableData: _vm.tableData,
          planId: _vm.planId,
          multipleChoiceOrNot: "",
        },
        on: { selectInvoice: _vm.selectInvoice },
      }),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.save } },
            [_vm._v("确 定")]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }